import t from "../../../utilities/tw.js";
const e = {
  label: t`h-5 text-center text-caption-md capitalize`,
  root: t`flex flex-col gap-y-3`,
  wrapper: t`inline-flex items-center gap-x-2`,
  focusOutline: t`focus-within:rounded-sm focus-within:outline focus-within:outline-2 focus-within:outline-offset-4 focus-within:outline-primary`
};
export {
  e as radioStyles
};
